export default __webpack_public_path__ + "static/pilates-745b75712618e76ad6f6e3bc0600e503.jpg";